/* eslint-disable no-nested-ternary */
import React, { ReactElement, ReactNode } from "react"

import Header from "@ecom/ui/components/Header/HeaderContainer"
import useMediaQuery from "@material-ui/core/useMediaQuery"

import { useObserver } from "../../../hooks/useObserver"

import { BlackHalvaLogo, RedHalvaWithSovcombank } from "../Logos"
import { RightSection } from "./RightSection/RightSection"
import { RightSectionNewDesign } from "./RightSectionNewDesign/RightSectionNewDesign"
import { DLClickEventExtended } from "../../../helpers/WatcherDL/DLEvents"

import * as styles from "./newHeader.module.scss"
import { WhiteLogoHalva } from "../Logos/WhiteLogoHalva/WhiteLogoHalva"

const options = {
  rootMargin: "0px 0px -50% 0px",
  threshold: 0,
}

const classesRedLogo = {
  logo: styles.logo,
}

export type HeaderProps = {
  children?: React.ReactNode
  buttonText?: string
  withoutHintAndCountDown?: boolean
  onlyGift?: boolean
  showHint?: boolean
  hasCTA?: boolean
  noRightSection?: boolean
  noShadow?: boolean
  countDownTime?: number
  withNav?: boolean
  newYear?: boolean
  hint?: ReactNode
  hintTitle?: ReactElement | string
  background?: string
  withButton?: boolean
  isCountdown?: boolean
  redLogoWithSovcombank?: boolean
  redirectLink?: string
  logoClick?: boolean
  isVisibleBlockTopCta?: boolean
  variantStyles?: "zadolzhennostej" | "newYearMedia" | "pravdaCoffee"
  urlForButtonRedirect?: string
  withScrollOnClickCountDown?: boolean
  countdownNewDesign?: boolean
  isSticky?: boolean
  backgroundColor?: string
}

export const NewHeader = ({
  children,
  buttonText = "Оформить карту",
  withoutHintAndCountDown = false,
  onlyGift = false,
  showHint = true,
  newYear = false,
  hasCTA = false,
  noRightSection = false,
  noShadow = true,
  countDownTime = 1800000,
  withNav = false,
  hint,
  hintTitle,
  background,
  withButton = true,
  isCountdown = true,
  redLogoWithSovcombank = false,
  redirectLink = "https://halvacard.ru/",
  logoClick = true,
  isVisibleBlockTopCta = false,
  variantStyles,
  urlForButtonRedirect,
  withScrollOnClickCountDown,
  countdownNewDesign,
  isSticky = true,
  backgroundColor,
}: HeaderProps) => {
  const isTab = useMediaQuery("(min-width:600px)")
  const isDesktop = useMediaQuery("(min-width:960px)")
  const isFormFocus = useObserver(["app"], options)
  const sticky = isSticky && isTab && (isDesktop ? true : !isFormFocus) && !isVisibleBlockTopCta
  const onLogoClick = () => {
    DLClickEventExtended({ name: "Логотип", eventAction: "Клик на логотип", placement: "header" })
    window.open(redirectLink, "_blank")
  }
  const isPravdaCoffeeVariant = variantStyles === "pravdaCoffee"
  const logo = redLogoWithSovcombank
    ? RedHalvaWithSovcombank
    : isPravdaCoffeeVariant
    ? WhiteLogoHalva
    : BlackHalvaLogo

  const rightSection = countdownNewDesign ? (
    <RightSectionNewDesign
      countDownTime={countDownTime}
      isHint
      buttonText={buttonText}
      hint={hint}
      background={background}
      hintTitle={hintTitle}
      isCountdown={isCountdown}
    />
  ) : (
    <RightSection
      countDownTime={countDownTime}
      withoutHintAndCountDown={withoutHintAndCountDown}
      onlyGift={onlyGift}
      showHint={showHint}
      hasCTA={hasCTA}
      buttonText={buttonText}
      newYear={newYear}
      hint={hint}
      background={background}
      hintTitle={hintTitle}
      isCountdown={isCountdown}
      variantStyles={variantStyles}
      urlForButtonRedirect={urlForButtonRedirect}
      withScrollOnClickCountDown={withScrollOnClickCountDown}
    />
  )

  return (
    <Header
      withNav={withNav}
      withButton={withButton}
      withPhone={false}
      right={countDownTime > 0 && !noRightSection && rightSection}
      onLogoClick={logoClick && onLogoClick}
      noShadow={noShadow}
      Logo={logo}
      sticky={sticky}
      classes={redLogoWithSovcombank && classesRedLogo}
      backgroundColor={backgroundColor}
    >
      {children}
    </Header>
  )
}
